/* Koji Footer - UX del form newsletter
   - messaggi di validazione in italiano
   - stato di invio (evita doppi invii)
   Listener delegati: funzionano anche quando la section viene ricaricata dal theme editor. */
(function () {
  'use strict';

  if (window.kojiFooterBound) return;
  window.kojiFooterBound = true;

  function isNewsletterInput(el) {
    return el && el.classList && el.classList.contains('koji-newsletter-input');
  }

  // Messaggi di validazione chiari invece di quelli generici del browser
  document.addEventListener('invalid', function (event) {
    var input = event.target;
    if (!isNewsletterInput(input)) return;
    input.setCustomValidity(
      input.validity.valueMissing
        ? 'Inserisci la tua email per iscriverti.'
        : 'Controlla l\u2019indirizzo email: non sembra valido.'
    );
  }, true);

  document.addEventListener('input', function (event) {
    if (isNewsletterInput(event.target)) event.target.setCustomValidity('');
  });

  // Stato di invio: disabilita il bottone e mostra lo spinner
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('koji-newsletter-form')) return;

    var button = form.querySelector('.koji-newsletter-btn');
    if (!button || button.disabled) return;

    // Disabilitiamo dopo il tick, così il form parte comunque
    window.setTimeout(function () {
      button.disabled = true;
      button.classList.add('is-loading');
      form.setAttribute('aria-busy', 'true');
    }, 0);
  });

  // Se l'utente torna indietro (cache del browser) il bottone torna attivo
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.koji-newsletter-btn.is-loading').forEach(function (button) {
      button.disabled = false;
      button.classList.remove('is-loading');
      var form = button.closest('form');
      if (form) form.removeAttribute('aria-busy');
    });
  });
})();